import * as timecardsActions from "./TimeCardsActionTypes";
import axios from "axios";
import Cookies from "js-cookie";
import { message } from "antd";

const jwtToken = Cookies.get("jwt_token");

//Get Invalid Clients
export const InvalidClients = (invalid) => {
  return {
    type: timecardsActions.AutoCrawlInvalidClients,
    payload: invalid,
  };
};

export const GetACFailedClients = (invalid) => {
  return async (dispatch) => {
    dispatch(InvalidClients(invalid));
  };
};

//Make an api call for getting auto crawl status
export const AutoCrawlStatus = (autocrawlstatus) =>{
  return{
    type:timecardsActions.AutoCrawlStatus,
    payload:autocrawlstatus
  }
}

export const GetAutoCrawlStatus = () => {
  return async (dispatch) => {
    const url = `${process.env.REACT_APP_BASE_URL}Home/autocrawlstatus`;
    const config = {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        Authorization: `Bearer ${jwtToken}`,
      },
    };
    axios.get(url, config).then((response) => {
      dispatch(AutoCrawlStatus(response.data));
    });
  };
};


//Data Validation Consolidated Report
export const DV_ConsolidatedReport = (DV_ConsolidatedReport) =>{
  return{
    type:timecardsActions.DataValidationConsolidation,
    payload:DV_ConsolidatedReport
  }
}

export const Get_DV_ConsolidatedReport = () => {
  return async (dispatch)=>{
    fetch(`${process.env.REACT_APP_BASE_URL}Paychex/GetClientsConsolidationReport`, {
      method: "GET",
      headers: {
        "content-type": "application/json",
        Authorization: `Bearer ${jwtToken}`,
      },
    })
      .then((resp) => resp.json())
      .then((resp) => {
        dispatch(DV_ConsolidatedReport(resp))
      });
  }
}

//Fetch ReConsolidation Clients
export const ReConsolidationClients = (ReConsolidation_Clients) =>{
  return{
    type: timecardsActions.FetchReConsolidationClients,
    payload:ReConsolidation_Clients
  }
}

export const Get_ReConsolidation_Clients = () => {
  return async (dispatch)=>{
    const url = `${process.env.REACT_APP_BASE_URL}ConsolidationReports/GetConsolidationFailedClients`;
    const config = {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        Authorization: `Bearer ${jwtToken}`,
      },
    };
    axios.get(url, config).then((response) => dispatch(ReConsolidationClients(response.data))).catch((error) => console.error(error));
  }
}

//Fetch ReConsolidation Client Header Data
export const ReConsolidationClientHeaderData = (ClientHeaderData) =>{
  return{
    type: timecardsActions.FetchReConsolidationClientHeaderData,
    payload:ClientHeaderData
  }
}

export const Get_ReConsolidation_Client_Header_Data = (ClientName) => {
  return async (dispatch)=>{
    const url = `${process.env.REACT_APP_BASE_URL}MasterLookupTable/GetClientdata?clientname=` + ClientName;
    const config = {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        Authorization: `Bearer ${jwtToken}`,
      },
    };
    axios.get(url, config).then((response) => {
      if(response.data.length=== 0) {
        message.warning(`No Headers Data for ${ClientName}`);
      }
      dispatch(ReConsolidationClientHeaderData(response.data));

    }).catch((error) => message.error("Please Try Again"));
  }
}


//OnChange Client Header Data
export const OnChangeClientHeaderData = (ClientHeaderData) =>{
  return{
    type: timecardsActions.OnChangeClientHeader,
    payload:ClientHeaderData
  }
}

export const OnChange_Client_Header_Data = (HeaderData) => {
  return async (dispatch)=>{
    dispatch(OnChangeClientHeaderData(HeaderData));
  }
}




//Update Client Header Data
export const UpdateClientHeader = () =>{
  return{
    type: timecardsActions.UpdateClientHeader,
    payload:{}
  }
}

export const Update_Client_Header_Action = (ClientName, UpdatedHeaderData) => {
  return async (dispatch)=>{
    const url = `${process.env.REACT_APP_BASE_URL}MasterLookupTable/UpdatenewData?clientname=` + ClientName;
    const config = {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        Authorization: `Bearer ${jwtToken}`,
      },
    };
    axios.put(url, UpdatedHeaderData,config).then((response) => {
      if(response.status === 200) {
        message.success(`${ClientName}'s Header Data Updated Successfully`);
        
      }
      dispatch(UpdateClientHeader());

    }).catch((error) => {
      dispatch(UpdateClientHeader());
      message.error("Please Try Again");
    });
  }
}